import HelpEmailLink, { type HelpEmailLinkProps } from './HelpEmailLink';

export default HelpEmailLink;
export type { HelpEmailLinkProps };
